module.exports = __webpack_public_path__ + "static/media/about-16.a9bb7929.png";